<tt-page *ngIf="!!get">
    <tt-page-heading [ttModel]="get.heading"></tt-page-heading>
    <tt-divider ttRememberId="prognosispurchase_dividier" class="flex-1">
        <tt-divider-rows>
            <tt-divider-pane>
                <tt-divider-columns>
                    <tt-divider-pane ttSize="15">
                        <tt-card>
                            <tt-select
                                ttRememberId="prognosispurchase_overview.businessco_no"
                                ttLabel="businessco_no"
                                [(ttModel)]="get.businessco_no"
                                (ttModelChange)="loadStockplaces(); readOverviewGrid()"
                                [ttData]="companies"
                                ttDataId="businessco_no"
                                ttDataName="company_name"
                                ttShowClearButton></tt-select>
                            <tt-select ttRememberId="prognosispurchase_overview.stockplace_id"
                                       ttLabel="stockplace_id"
                                       [(ttModel)]="get.stockplace_id"
                                       (ttModelChange)="readOverviewGrid()"
                                       [ttData]="stockplaces"
                                       ttDataId="stockplace_id"
                                       ttDataName="stockplace_name"
                                       ttShowClearButton></tt-select>
                            <tt-date-range ttRememberId="prognosispurchase_overview"
                                           ttLabel="dato_fomtom"
                                           [(ttStartDate)]="get.date_fom"
                                           [(ttEndDate)]="get.date_tom"
                                           [(ttInterval)]="get.date_interval"
                                           (ttModelChange)="readOverviewGrid()"></tt-date-range>
                            <tt-search ttRememberId="prognosispurchase_overview.supplier_no"
                                       ttLabel="supplier"
                                       [(ttModel)]="get.supplier_name"
                                       [ttSearch]="searchSupplier"
                                       (ttOnSelected)="onSupplierSelected($event)"
                                       (ttOnClear)="onSupplierSelected()"
                                       ttShowClearButton></tt-search>
                            <tt-input-number ttRememberId="prognosispurchase_overview.weeks_pr_period"
                                             ttLabel="weeks_pr_period"
                                             [(ttModel)]="get.weeks_pr_period"
                                             (ttModelChange)="onWeeksPrPeriodChanged()"
                                             ttDecimals="0"
                                             ttAlwaysPositive></tt-input-number>
                        </tt-card>
                    </tt-divider-pane>
                    <tt-divider-pane ttSize="85">
                        <tt-grid
                            *ngIf="!!overviewGrid"
                            (ttOnRead)="selectedRow = undefined"
                            (ttOnRebind)="selectedRow = undefined"
                            [(ttOptions)]="overviewGrid"
                            ttRowSelection="single"
                            (ttOnRowSelected)="onPrognosisSelected($event)"
                            (ttReady)="onOverviewGridReady()"
                        >
                        </tt-grid>
                    </tt-divider-pane>
                </tt-divider-columns>
            </tt-divider-pane>
            <tt-divider-pane>
                <tt-grid *ngIf="!!detailGrid && !!selectedRow" [(ttOptions)]="detailGrid"> </tt-grid>
            </tt-divider-pane>
        </tt-divider-rows>
    </tt-divider>
</tt-page>
